(function () {
    'use strict';

    angular.module('app.vendortypes', [
        // Angular modules 
        'ngRoute',
        'ngFileUpload'

        // Custom modules 

        // 3rd Party Modules
        
    ]);
})();